import { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { AppBar } from '@mui/material';
import { Link } from 'react-router-dom';
import '../assets/Layout.css';

function samePageLinkNavigation(
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
) {
    if (
        event.defaultPrevented ||
        event.button !== 0 || // ignore everything but left-click
        event.metaKey ||
        event.ctrlKey ||
        event.altKey ||
        event.shiftKey
    ) {
        return false;
    }
    return true;
}

export const Layout = () => {
    const [tabValue, setTabValue] = useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        if (
            event.type !== 'click' ||
            (event.type === 'click' &&
            samePageLinkNavigation(
                event as React.MouseEvent<HTMLAnchorElement, MouseEvent>,
            ))
        ) {
            setTabValue(newValue);
        }
    };

    
    return (
        <AppBar position="static">
            <div className='title-row'>
                Silicon Valley RFC
            </div>
            <Tabs 
                value={tabValue}
                className='navigation-row'
                onChange={handleChange}
                indicatorColor="secondary"
                textColor="inherit"
                variant="standard"
                aria-label="Nav Tabs"
            >
                <Tab component={Link} label="Home" to="/"/>
                <Tab component={Link} label="About Us" to="/about-us"/>
                <Tab component={Link} label="Registration" to="/registration"/>
                {/* 
                <Tab component={Link} label="Calendar" to="/calendar"/>
                <Tab component={Link} label="Events" to="/events"/>
                <Tab component={Link} label="Assets" to="/assets"/>
                <Tab component={Link} label="Teams" to="/teams"/>
                <Tab component={Link} label="Dibs???" to="/dibs"/> */}
            </Tabs>
        </AppBar>
    );
}